import { render, staticRenderFns } from "./ZusatzangabenFirma.vue?vue&type=template&id=4a95a797"
import script from "./ZusatzangabenFirma.vue?vue&type=script&lang=js"
export * from "./ZusatzangabenFirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports